import { useEffect, useState } from "react";
import api from "../lib/api";
import BrandHeader from "../components/brand/BrandHeader";
import Footer from "../components/brand/Footer";
import { GALLERY_IMAGES, shortDate } from "../lib/brand";

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(({ data }) => setEvents(data)); }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      <BrandHeader />
      <section className="max-w-7xl mx-auto px-6 py-12">
        <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">The Calendar</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl text-white">Upcoming Nights</h1>
        <p className="text-white/60 mt-3 max-w-2xl">Curated live music, exclusive openings, and private tastings across the network.</p>

        {events.length === 0 ? (
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {[0,1,2].map((i) => (
              <div key={i} className="tsc-card overflow-hidden">
                <img src={GALLERY_IMAGES[i % GALLERY_IMAGES.length]} alt="" className="aspect-[4/3] object-cover w-full opacity-60" />
                <div className="p-5">
                  <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Coming soon</p>
                  <p className="font-display text-xl text-white mt-2">A new evening, curated by The Social Circle.</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {events.map((e) => (
              <div key={e.id} className="tsc-card overflow-hidden" data-testid={`event-${e.id}`}>
                {e.cover_url && <img src={e.cover_url} alt={e.title} className="aspect-[4/3] object-cover w-full" />}
                <div className="p-5">
                  <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">{shortDate(e.starts_at)}</p>
                  <p className="font-display text-xl text-white mt-2 leading-tight">{e.title}</p>
                  {e.description && <p className="text-white/60 text-sm mt-2 line-clamp-3">{e.description}</p>}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
